import { useAuth } from '@/api/auth'
import type { WarehouseCompanyFilter as CompanyFilter } from '@/lib/warehouse-company'

const BUTTONS = [['stahlia', 'Stahlia'], ['priostahl', 'Priostahl'], ['both', 'Beide']] as const

export function WarehouseCompanyFilter<T extends CompanyFilter | 'neutral'>({ value, onChange, includeNeutral = false, buttons = false, includeBoth = true }: { value: T; onChange: (company: T) => void; includeNeutral?: boolean; buttons?: boolean; includeBoth?: boolean }) {
  const { warehouse } = useAuth()
  if (!warehouse.lead) return <span className="text-sm text-muted">Stahlia</span>
  // Knopfleiste statt Auswahlmenue: ein Klick, die gewaehlte Firma ist immer sichtbar.
  if (buttons) return <div role="group" aria-label="Firma" className="flex items-center gap-2 text-sm">
    <span>Firma</span>
    <div className="inline-flex rounded-md border border-line bg-panel p-0.5">
      {BUTTONS.filter(([key]) => includeBoth || key !== 'both').map(([key, label]) => (
        <button key={key} type="button" aria-pressed={value === key} onClick={() => onChange(key as T)}
          className={`px-3 py-1.5 rounded text-sm focus-visible:outline-2 focus-visible:outline-primary ${value === key ? 'bg-primary text-primary-foreground font-medium' : 'text-muted hover:text-ink'}`}>
          {label}
        </button>
      ))}
    </div>
  </div>
  return <label className="flex items-center gap-2 text-sm">Firma
    <select aria-label="Firma" value={value} onChange={e => onChange(e.target.value as T)}
      className="rounded-md border border-line bg-panel p-2 focus-visible:outline-2 focus-visible:outline-primary">
      <option value="both">Stahlia und Priostahl</option><option value="stahlia">Stahlia</option><option value="priostahl">Priostahl</option>
      {includeNeutral && <option value="neutral">Gesamtes Journal – Firma nicht ausgewiesen</option>}
    </select>
  </label>
}
